import React from 'react';
import { withLocalize, Translate } from 'react-localize-redux';
import Bad from '../../../img/quality/bad';
import Worse from '../../../img/quality/worse';
import Neutral from '../../../img/quality/neutral';
import Better from '../../../img/quality/better';
import Good from '../../../img/quality/good';
import BbPopover from '../../common/popover';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';

class FinStatement extends React.Component {
    render() {
        let data = this.props.data;

        if (data === undefined || data === null || data.fRows.length === 0)
            return null
        return (
            <OldStyleTableWithHistory tableColumns={5} stripped
                actualData={data.fRows.map((fs, i) => ({ ...fs, index: i}))}
                head={() => <thead>
                    <tr>
                        <th><Translate id="Report.Ratings.SelectedFinancialRatios" /></th>
                        <th style={{ width: "20%", textAlign: "right" }}><Translate id="Report.Ratings.Trend" /></th>
                        <th style={{ width: "20%", textAlign: "right" }}>{data.latest}</th>
                        <th style={{ width: "4em" }} />
                        <th style={{ width: "20%", textAlign: "right" }}>{data.oldest}</th>
                    </tr>
                </thead>}
                actualRow={(r) => <tr key={r.index} className="colorize">
                    <td><Translate id={`Report.Ratings.${r.code.replace(/_/g, ".")}`} /></td>
                    <td style={{ textAlign: "right" }}>{r.trend}</td>
                    <td style={{ textAlign: "right" }}>{r.value}</td>
                    <BbPopover
                        content={this.props.translate(`Report.Ratings.QualityTooltip${r.quality}`)}
                        placement="top"
                        targetId={`tdQ${r.index}`}
                        toggleOnEvent="toggleOnMouse"
                    >
                        <td style={{ paddingLeft: "0" }} id={`tdQ${r.index}`}>
                            <div className="fin-stat-quality-indicator">
                                {this.getQualityIndicator(r.quality)}
                            </div>
                        </td>
                    </BbPopover>
                    <td style={{ textAlign: "right" }}>{r.value2}</td>
                </tr>}
            />
        );
    }

    getQualityIndicator(q) {
        switch (q) {
            case "01":
                return <Bad />
            case "02":
                return <Worse />;
            case "03":
                return <Neutral />
            case "04":
                return <Better />;
            case "05":
                return <Good />;
            default:
                return null;
        }
    }
    getQualityIndicatorDesc(q) {
        switch (q) {
            case "01":
                return "Common.Bad";
            case "02":
                return "Common.Worse";
            case "03":
                return "Common.Neutral";
            case "04":
                return "Common.Better";
            case "05":
                return "Common.Good";
            default:
                return null;
        }
    }
}

export default withLocalize(FinStatement);